import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class DataMatchHeight {
	constructor() {
		this.containers = document.querySelectorAll("[data-mh-container]");

		if (this.containers.length) {
			this.execute();
			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	execute() {
		this.containers.forEach(container => {
			const items = container.querySelectorAll("[data-mh]");
			let maxHeight = 0;

			gsap.set(items, {
				height: "auto"
			});

			items.forEach(inner => {
				if (inner.clientHeight > maxHeight) {
					maxHeight = inner.clientHeight;
				}
			});

			gsap.set(items, {
				height: maxHeight
			});
		});
	}

	resize() {
		this.execute();
	}
}
